import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Experiences from "../components/Experiences";
import About from "../components/About";
import WhyUs from "../components/WhyUs";
import Offers from "../components/Offers";
import Addons from "../components/Addons";
import Testimonials from "../components/Testimonials";
import CTABand from "../components/CTABand";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import Seo from "../components/Seo";
import { FEATURE_FLAGS } from "../data/site";
import { useLang } from "../data/i18n";
import { homePageSchemas } from "../lib/schema";

export default function Home() {
    const { lang, t, prefix } = useLang();
    return (
        <>
            <Seo
                title={t.seoHome.title}
                description={t.seoHome.description}
                path={prefix || "/"}
                lang={lang}
                jsonLd={{ "@context": "https://schema.org", "@graph": homePageSchemas(lang) }}
            />
            <Header />
            <main>
                <Hero />
                <Experiences />
                <About />
                <WhyUs />
                <Offers />
                <Addons />
                {FEATURE_FLAGS.showTestimonials && <Testimonials />}
                <CTABand />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
        </>
    );
}
